import { AfterViewChecked, AfterViewInit, Component, ElementRef, inject, Input, OnInit, ViewChild } from '@angular/core';
import { Match } from '../../_shared/models/match.model';
import { Tie } from '../../_shared/models/tie.model';
import { CommonModule } from '@angular/common';
import { IonicModule, ModalController, Platform } from '@ionic/angular';
import { SubPlayerComponent } from '../sub-player/sub-player.component';
import { Team } from '../../_shared/models/team.model';
import { Subject, takeUntil } from 'rxjs';
import { MatchService } from '../../_core/services/match.service';
import { ActivePlayer } from '../../_shared/models/participant';
import { User } from '../../_shared/models/user.model';

@Component({
  selector: 'app-sub-modal',
  templateUrl: './sub-modal.component.html',
  styleUrls: ['./sub-modal.component.scss'],
  standalone: true,
  imports:[CommonModule, IonicModule, SubPlayerComponent]
})
export class SubModalComponent  implements OnInit {
    matchService = inject(MatchService);
    private readonly destroy$: Subject<void> = new Subject();
    @Input({required: false}) match: Match;
    @Input({required: false}) tie: Tie;
    @Input({required: false}) sideNumber: number;
    @ViewChild('teamName', { read: ElementRef }) teamName: ElementRef | undefined;
    @ViewChild('mainPlayer', { read: ElementRef }) mainPlayer: ElementRef | undefined;
    @ViewChild('subSelect', { read: ElementRef }) subSelect: ElementRef | undefined;
    @ViewChild('footer', { read: ElementRef }) footer: ElementRef | undefined;
    @ViewChild('modal', { read: ElementRef }) modal: ElementRef | undefined;
    @Input() onSubPlayerSelected: (player: any) => void;

  team: Team;
  player: any;
  activePlayerId: string | null = null;
  subPlayerId: string | null = null;
  selectedPlayerNumber: number;
  isChecked: boolean = false;
  rowHeight!: number;
  subPlayerInfo: User;

  constructor(
    private readonly modalController: ModalController, 
    public platform: Platform,) { }

  ngOnInit() {
    this.team = this.tie?.sides[this.sideNumber - 1]?.team;
    this.getActivePlayer();
    this.subscriptions();

      setTimeout(() => {
        this.rowHeight = this.getRowHeight();
      }, 100);
  }

  async ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getActivePlayer(){
    const subPlayer = this.tie?.sides[this.sideNumber - 1]?.team?.participants;
    const activePlayer = this.match.sides[this.sideNumber - 1]?.players;
    let matchedActivePlayers : any = [];
    let unmatchedSubPlayers : any = [];
        if(subPlayer){
        subPlayer.forEach(sub => {
        const activePlayers = activePlayer.filter(active => active.participant._id === sub.person._id);

          if (activePlayers.length > 0) {
            matchedActivePlayers.push({...sub, playerNumber: activePlayers[0].playerNumber});
          } else {
            unmatchedSubPlayers.push(sub);
          }
        });

        // Sort matchedActivePlayers by playerNumber in ascending order
        matchedActivePlayers.sort((a, b) => a.playerNumber - b.playerNumber);

        this.player = {
          activePlayer: matchedActivePlayers,
          subPlayer: unmatchedSubPlayers
        };

        if (this.match.matchType.toLowerCase() === 's') {
            this.selectedPlayerNumber = matchedActivePlayers[0]?.playerNumber;
            this.activePlayerId = matchedActivePlayers[0]?.person?._id;
            this.isChecked = true;
          }
    }
  }

  updatePlayer(){
    this.modalController.dismiss({
      endSub: true,
      sideNumber: this.sideNumber,
      playerNumber: this.selectedPlayerNumber,
      inPlayerId: this.subPlayerInfo?._id,
      outPlayerId: this.activePlayerId,
      subPlayerInfo: this.subPlayerInfo,
    });
  }

  dismiss(){
    this.modalController.dismiss();
  }

  activePlayerSelected(data: ActivePlayer){
    this.activePlayerId = data?.playerInfo?.person?._id || '';
    this.selectedPlayerNumber = data.playerNumber;
    this.isChecked = data.checked;
  }
  subPlayerSelected(data: ActivePlayer){
    this.subPlayerInfo = data?.playerInfo?.person;
     if (this.onSubPlayerSelected) {
      this.onSubPlayerSelected(data);
    }
  }

    async subscriptions() {
      this.matchService
        .subscribeScoreUpdated()
        .pipe(takeUntil(this.destroy$))
        .subscribe((match: Match) => {
          if (this.match._id === match._id) {
            this.match = match;
            const subs = this.match?.substituteTrack?.['side' + this.sideNumber];
            if (Array.isArray(subs) && subs.some(t => t.isSubEnd)) {
              this.modalController.dismiss();
            }            
          }
      });
    }

    getRowHeight(): number {
        const modal = this.modal?.nativeElement?.offsetHeight || 0;
        const teamName = this.teamName?.nativeElement.offsetHeight;
        const mainPlayer = this.mainPlayer?.nativeElement?.offsetHeight || 0;
        const subSelect = this.subSelect?.nativeElement?.offsetHeight || 40;
        // Calculate the height of the modal content
        return modal - teamName - mainPlayer  - subSelect - 20;
      }
}
